import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstatnts } from 'src/app/common/constants/app-contstants';
import { EditorMode } from 'src/app/common/enums/enums';
import { NotifierV2Service } from 'src/app/services/notifier-v2.service';

@Component({
    selector: 'app-editor-menu',
    templateUrl: './editor-menu.component.html',
    styleUrls: ['./editor-menu.component.scss'],
    standalone: false
})
export class EditorMenuComponent implements OnInit {

  @Input() showTreeEditor;
  @Input() showFamilyEditor;
  @Input() showMemberEditor;
  isMemberEditorOpen: boolean = false;
  isTreeEditorOpen: boolean = false;
  isFamilyEditorOpen: boolean = false;
  EditorMode = EditorMode;

  constructor(private router: Router,
    private notifierService : NotifierV2Service,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    let urls = this.router.url;
    this.activatedRoute.url.subscribe(res => {
      this.updateOpenedTab(this.router.url);
    });

  }

  openEditor(mode: EditorMode) {
    let data = {
      id : (mode === EditorMode.FamilyEditor) ? this.notifierService.getCurrentRootFamilyId() : this.notifierService.getCurrentRootMemberId(),
      editorMode: mode,
      isUpdateHistory: true
    }
    
    this.notifierService.setCurrentEditor(AppConstatnts.routerModes[EditorMode[mode]], data, null);
  } 

  updateOpenedTab(currentUrl): void {
    setTimeout(() => {
      this.isMemberEditorOpen = currentUrl.indexOf('individualeditor') > 0;
      this.isFamilyEditorOpen = currentUrl.indexOf('familyeditor') > 0;
      this.isTreeEditorOpen = currentUrl.indexOf('treeeditor') > 0;
    }, 1);
  }
}
